/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-toolbar.secondary-menu[_ngcontent-%COMP%]{height:30px;background-color:#f0f0f0}mat-sidenav-container[_ngcontent-%COMP%]{position:relative;min-height:100vh;color:#fff}mat-sidenav[_ngcontent-%COMP%], mat-sidenav-content[_ngcontent-%COMP%]{padding:16px;max-width:400px;min-width:200px;width:22vw}mat-sidenav[_ngcontent-%COMP%]{background-color:#25274d}.sidebar[_ngcontent-%COMP%]{min-height:70vh}#outlet[_ngcontent-%COMP%]{padding:20px}"];
export { styles as styles };
